// src/pages/delivery/DeliveryOrdersPage.jsx
import React from "react";
import DeliveryOrderList from "../../components/delivery/DeliveryOrderList";

const DeliveryOrdersPage = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">My Orders</h1>
        <p className="text-gray-600 mt-1">
          Manage and track your assigned deliveries
        </p>
      </div>
      <DeliveryOrderList />
    </div>
  );
};

export default DeliveryOrdersPage;
